var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.componentParams.is_active)?_c('AIconButton',{staticClass:"o-integration-close-button",attrs:{"icon":"close-otg-black"},on:{"onClick":function($event){return _vm.handleClick()}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }